import { render, staticRenderFns } from "./OrticAttachment.vue?vue&type=template&id=4956e72b&"
import script from "./OrticAttachment.vue?vue&type=script&lang=js&"
export * from "./OrticAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports